import Vue from 'vue'
import uap from 'ua-parser-js'

const lc = s => (typeof s !== 'string') ? s : s.toLowerCase()
Vue.filter('lc', lc)

const uc = s => (typeof s !== 'string') ? s : s.toUpperCase()
Vue.filter('uc', uc)

const ucfirst = s => (typeof s !== 'string') ? s : s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
Vue.filter('ucfirst', ucfirst)

const ucwords = s => {
  if (typeof s === 'string') {
    s = s.split(' ').map(p => ucfirst(p)).join(' ')
    s = s.split('/').length > 1 ? s.split('/').map(p => ucfirst(p)).join('/') : s
  }

  return s
}
Vue.filter('ucwords', ucwords)

const removeDashes = s => (typeof s !== 'string') ? s : s.split('_').join(' ')
Vue.filter('removeDashes', removeDashes)

const NA = s => (typeof s !== 'string') ? 'N/A' : s
Vue.filter('NA', NA)

const getBrowser = s => {
  const ua = uap(s)

  return ua.browser.name +' '+ ua.browser.version
}
Vue.filter('getBrowser', getBrowser)

const getOS = s => {
  const ua = uap(s)

  return ua.os.name +' '+ ua.os.version
}
Vue.filter('getOS', getOS)

export default {
  lc,
  uc,
  ucfirst,
  ucwords,
  removeDashes
}
